// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['am_ET']  = {
  "name": "am_ET",
  "day": {
    "abbrev": [
      "እሑድ",
      "ሰኞ ",
      "ማክሰ",
      "ረቡዕ",
      "ሐሙስ",
      "ዓርብ",
      "ቅዳሜ"
    ],
    "full": [
      "እሑድ",
      "ሰኞ",
      "ማክሰኞ",
      "ረቡዕ",
      "ሐሙስ",
      "ዓርብ",
      "ቅዳሜ"
    ]
  },
  "month": {
    "abbrev": [
      "ጃንዩ",
      "ፌብሩ",
      "ማርች",
      "ኤፕረ",
      "ሜይ ",
      "ጁን ",
      "ጁላይ",
      "ኦገስ",
      "ሴፕቴ",
      "ኦክተ",
      "ኖቬም",
      "ዲሴም"
    ],
    "full": [
      "ጃንዩወሪ",
      "ፌብሩወሪ",
      "ማርች",
      "ኤፕረል",
      "ሜይ",
      "ጁን",
      "ጁላይ",
      "ኦገስት",
      "ሴፕቴምበር",
      "ኦክተውበር",
      "ኖቬምበር",
      "ዲሴምበር"
    ]
  },
  "meridiem": [
    "ጡዋት",
    "ከሰዓት"
  ],
  "date": "%d/%m/%Y",
  "time24": "%l:%M:%S",
  "dateTime": "%A፣ %B %e ቀን %Y %r %Z",
  "time12": "%X %p",
  "full": "%A፣ %B %e ቀን %r %Z %Y ዓ/ም"
}

